import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Toolbar from './components/Toolbar';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import ResponsiveShadow from './components/ResponsiveShadow';
import './css/Cliente.css';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import { formatDateView } from './utils/dateUtils';
import Pagination10 from './components/Pagination10';
import PageFooter from './components/PageFooter';
import { formatString } from './utils/StringUtils';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ReprovaDfdModal from './components/modalServices/ReprovaDfdModal';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import usePagination10 from './components/hooks/usePagination10';
import useReprovaDfdModal from './components/hooks/useReprovaDfdModal';
import useDevolveDfdModal from './components/hooks/useDevolveDfdModal';
import useReverteDfdModal from './components/hooks/useReverteDfdModal';
import DevolveDfdModal from './components/modalServices/DevolveDfdModal';
import ReverteDfdModal from './components/modalServices/ReverteDfdModal';
import Layout from './components/Layout';
import TableContainer from './components/TableContainer';
import TableHeader from './components/TableHeader';
import { isSuperAdmin, isPrivilegedAdmin } from '../utils/userUtils';


function AprovaDfd() {
  const [dfds, setDfds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isExporting, setIsExporting] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // índice do registro selecionado
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const anoBase = localStorage.getItem('anoBase');
  const login = localStorage.getItem('login');

  // Dados do usuário para controle de permissões
  const usuarioBind = JSON.parse(localStorage.getItem('usuarioBind') || '{}');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const navigate = useNavigate();
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const { setReprovaDfdModal, showReprovaDfdModal, closeReprovaDfdModal } = useReprovaDfdModal();
  const { setDevolveDfdModal, showDevolveDfdModal, closeDevolveDfdModal } = useDevolveDfdModal();
  const { setReverteDfdModal, showReverteDfdModal, closeReverteDfdModal } = useReverteDfdModal();
  const [isProcessing, setIsProcessing] = useState(false);
  const [filtroTramitacao, setFiltroTramitacao] = useState('TODOS');
  const [expandedRows, setExpandedRows] = useState({});

  const toggleExpand = (rowKey) => {
    setExpandedRows(prev => ({ ...prev, [rowKey]: !prev[rowKey] }));
  };

  // Função para gerenciar seleção/desseleção de DFD
  const handleRowClick = idx => {
    // Se clicar no mesmo índice já selecionado, desmarca
    if (selectedRow === idx) {
      setSelectedRow(null);
    } else {
      setSelectedRow(idx);
    }
  };
  const dfdsFiltrados =
    filtroTramitacao === 'TODOS'
      ? dfds
      : dfds.filter(item => item.tramitacao === filtroTramitacao);

  const totalItems = dfdsFiltrados.length;
  const { setPagination } = usePagination10(totalItems);

  const selectedDfds = dfdsFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  // Registro selecionado (objeto)
  const selectedDfd =
    selectedRow !== null && selectedDfds[selectedRow]
      ? selectedDfds[selectedRow]
      : null;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL.DFD}/tramitacaoAprovacao`, {
        params: {
          cnpj: cnpj,
          anoBase: anoBase,
        },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setDfds(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter listas:', error);
        navigate('/');
      });
  }, []);

  if (!dfds) {
    return <div>Loading...</div>;
  }

  function handleAprova(dfd) {
    const tramitacao = {
      cnpjEntidade: dfd.cnpj,
      dfdNum: dfd.num,
      data: new Date(),
      descricao: 'APROVADO',
      justificativa: 'APROVADO COM SUCESSO!',
      obs: 'APROVADO COM SUCESSO!',
      usuario: login,
    };
    showConfirmModal('aprova', () => handleAprovaConfirm(tramitacao, dfd));
  }

  function handleAprovaConfirm(tramitacao, dfd) {
    if (tramitacao) {
      axios
        .post(`${API_BASE_URL.TRAMITACAO}/save`, tramitacao, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          handleUpdate(dfd);
        })
        .catch(error => {
          console.error('Erro ao salvar o registro:', error);
          showDefaultModal('error', 'Erro ao savar o registro');
        });
    }
  }

  function handleUpdate(dfd) {
    const updatedFormData = {
      ...dfd,
      tramitacao: 'APROVADO',
      usuario: login,
    };
    axios
      .post(`${API_BASE_URL.DFD}/updateTramitacao`, updatedFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setDfds(prevState =>
          prevState.map(item =>
            item.num === dfd.num ? { ...item, tramitacao: 'APROVADO' } : item
          )
        );
        showDefaultModal('success', 'O registro foi aprovado com sucesso');
      })
      .catch(error => {
        console.error('Erro ao enviar o registro para aprovação:', error);
        showDefaultModal('error', 'Erro ao enviar o registro para aprovação!');
      });
  }

  // Função de reprovação atualizada
  const handleReprovaConfirm = async (dfd, justificativa) => {
    setIsProcessing(true);
    try {
      const tramitacao = {
        cnpjEntidade: dfd.cnpj,
        dfdNum: dfd.num,
        data: new Date(),
        descricao: 'REPROVADO',
        justificativa: justificativa,
        usuario: login,
      };
      await axios.post(`${API_BASE_URL.TRAMITACAO}/save`, tramitacao, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const updatedFormData = {
        ...dfd,
        tramitacao: 'REPROVADO',
        usuario: login,
      };

      await axios.post(
        `${API_BASE_URL.DFD}/updateTramitacao`,
        updatedFormData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setDfds(prevState =>
        prevState.map(item =>
          item.num === dfd.num ? { ...item, tramitacao: 'REPROVADO' } : item
        )
      );
      showDefaultModal('success', 'DFD reprovado com sucesso');
    } catch (error) {
      console.error('Erro ao reprovar DFD:', error);
      showDefaultModal('error', 'Erro ao reprovar o DFD');
    } finally {
      setIsProcessing(false);
      closeReprovaDfdModal();
    }
  };

  // Função para abrir o modal
  const handleReprova = dfd => {
    showReprovaDfdModal(dfd, justificativa => {
      handleReprovaConfirm(dfd, justificativa);
    });
  };

  const handleDevolveConfirm = async (dfd, justificativa) => {
    setIsProcessing(true);
    try {
      const tramitacao = {
        cnpjEntidade: dfd.cnpj,
        dfdNum: dfd.num,
        data: new Date(),
        descricao: 'DEVOLVIDO PARA AJUSTES',
        justificativa: justificativa,
        usuario: login,
      };
      await axios.post(`${API_BASE_URL.TRAMITACAO}/save`, tramitacao, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const updatedFormData = {
        ...dfd,
        tramitacao: 'DEVOLVIDO PARA AJUSTES',
        usuario: login,
      };

      await axios.post(
        `${API_BASE_URL.DFD}/updateTramitacao`,
        updatedFormData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setDfds(prevState =>
        prevState.map(item =>
          item.num === dfd.num
            ? { ...item, tramitacao: 'DEVOLVIDO PARA AJUSTES' }
            : item
        )
      );
      showDefaultModal('success', 'DFD devolvido com sucesso');
    } catch (error) {
      showDefaultModal('error', 'Erro ao devolver o DFD');
    } finally {
      setIsProcessing(false);
      closeDevolveDfdModal();
    }
  };

  // Função para abrir o modal
  const handleDevolve = dfd => {
    showDevolveDfdModal(dfd, justificativa => {
      handleDevolveConfirm(dfd, justificativa);
    });
  };

  // Função para reverter DFD (voltar para ENVIADO PARA APROVAÇÃO)
  const handleReverter = dfd => {
    showReverteDfdModal(dfd, justificativa => {
      handleReverterConfirm(dfd, justificativa);
    });
  };

  const handleReverterConfirm = async (dfd, justificativa) => {
    setIsProcessing(true);
    try {
      const tramitacao = {
        cnpjEntidade: dfd.cnpj,
        dfdNum: dfd.num,
        data: new Date(),
        descricao: 'DEVOLVIDO PARA AJUSTES',
        justificativa: justificativa,
        usuario: 'SUPORTE',
      };

      await axios.post(`${API_BASE_URL.TRAMITACAO}/save`, tramitacao, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const updatedFormData = {
        ...dfd,
        tramitacao: 'DEVOLVIDO PARA AJUSTES',
        usuario: 'SUPORTE',
      };

      await axios.post(
        `${API_BASE_URL.DFD}/updateTramitacao`,
        updatedFormData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setDfds(prevState =>
        prevState.map(item =>
          item.num === dfd.num
            ? { ...item, tramitacao: 'DEVOLVIDO PARA AJUSTES' }
            : item
        )
      );
      showDefaultModal('success', 'DFD revertido com sucesso');
    } catch (error) {
      console.error('Erro ao reverter DFD:', error);
      showDefaultModal('error', 'Erro ao reverter o DFD');
    } finally {
      setIsProcessing(false);
      closeReverteDfdModal();
    }
  };

  async function handlePrint(dfd) {
    setIsExporting(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL.DFD}/preencherDfd`,
        dfd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          responseType: 'blob',
        }
      );
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `DFD ${formatString(dfd.num, 4)}.docx`;
      link.click();
    } catch (error) {
      console.error('Erro ao preencher o template:', error);
      showDefaultModal('error', 'Erro ao preencher o template.');
    } finally {
      setIsExporting(false);
    }
  }

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Aprovação de DFD" icon="bi-file-earmark-text" backButton={false} closeRoute="/home" />
        <PageContent style={{ paddingBottom: 0 }}>
          <Toolbar
            selectedId={selectedDfd}
            actions={[
              { key: 'aprovar', label: 'Aprovar', icon: 'bi-check2-square', variant: 'success', onClick: dfd => handleAprova(dfd), show: selectedDfd?.tramitacao === 'ENVIADO PARA APROVAÇÃO' },
              { key: 'reprovar', label: 'Reprovar', icon: 'bi-x-square', variant: 'danger', onClick: dfd => handleReprova(dfd), show: selectedDfd?.tramitacao === 'ENVIADO PARA APROVAÇÃO' },
              { key: 'devolver', label: 'Devolver para Ajustes', icon: 'bi-upload', variant: 'warning', onClick: dfd => handleDevolve(dfd), show: selectedDfd?.tramitacao === 'ENVIADO PARA APROVAÇÃO' },
              { key: 'reverter', label: 'Reverter', icon: 'bi-arrow-counterclockwise', variant: 'info', onClick: dfd => handleReverter(dfd), show: usuarioBind.tipo === 'ADMIN' && user.role === 'ADMIN' && isPrivilegedAdmin(user, usuarioBind) && (selectedDfd?.tramitacao === 'APROVADO' || selectedDfd?.tramitacao === 'REPROVADO') },
              { key: 'itens', label: 'Itens', icon: 'bi-boxes', variant: 'primary', onClick: dfd => navigate('/aprova_dfd_itens', { state: { dfd } }), requiresSelection: true },
              { key: 'imprimir', label: 'Imprimir', icon: 'bi-printer', variant: 'secondary', onClick: dfd => handlePrint(dfd), requiresSelection: true },
            ]}
            searchControls={(
              <div className="d-flex align-items-center">
                <label className="form-label me-2 mb-0 small text-muted">Filtro:</label>
                <select className="form-select form-select-sm filter-select-compact" value={filtroTramitacao} onChange={e => setFiltroTramitacao(e.target.value)} aria-label="Filtro de tramitação" style={{ minWidth: '260px' }}>
                  <option value="TODOS">Todos</option>
                  <option value="ENVIADO PARA APROVAÇÃO">Aguardando aprovação</option>
                  <option value="APROVADO">Aprovados</option>
                  <option value="DEVOLVIDO PARA AJUSTES">Devolvidos para ajustes</option>
                  <option value="REPROVADO">Reprovados</option>
                </select>
              </div>
            )}
          />

          <TableContainer tableClass="table-custom-radius">
        <TableHeader columns={[
          { label: 'DFD', width: '7%' },
          { label: 'Data da Contratação', width: '7%' },
          { label: 'Área Requisitante', width: '20%' },
          { label: 'Tipo', width: '10%' },
          { label: 'Agrupamento', width: '10%' },
          { label: 'Objeto' },
          { label: 'Tramitação', width: '15%' },
        ]} />
        <tbody>
          {selectedDfds.length > 0 ? (
            selectedDfds.map((c, idx) => (
              <tr
                key={`${c.cnpj}-${c.num}`}
                className={selectedRow === idx ? 'table-primary fw-bold' : ''}
                style={{ cursor: 'pointer' }}
                onClick={() => handleRowClick(idx)}
                title={
                  selectedRow === idx
                    ? 'Clique novamente para desmarcar'
                    : 'Clique para selecionar'
                }
              >
                <td style={{ width: '5%' }}>{formatString(c.num, 4)}</td>
                <td style={{ width: '7%' }}>
                  {formatDateView(c.dataContratacao)}
                </td>
                <td style={{ width: '20%' }}>{c.requisitante}</td>
                <td style={{ width: '10%' }}>{c.tipo}</td>
                <td style={{ width: '10%' }}>{c.agrupamento}</td>
                <td>
                  {(() => {
                    const rowKey = `${c.cnpj}-${c.num}`;
                    const desc = c.objeto || '';
                    const isExpanded = !!expandedRows[rowKey];
                    const limit = 80;
                    const shortDesc = desc.length > limit ? desc.slice(0, limit) + '...' : desc;
                    return (
                      <>
                        {desc.length > limit && (
                            <button
                              type="button"
                              className="btn btn-link btn-sm p-0 me-1 align-middle"
                              style={{ verticalAlign: 'middle', color: '#000' }}
                            onClick={(e) => { e.stopPropagation(); toggleExpand(rowKey); }}
                            aria-expanded={isExpanded}
                            aria-label={isExpanded ? 'Recolher objeto' : 'Expandir objeto'}
                          >
                            <i className={`bi ${isExpanded ? 'bi-dash-circle' : 'bi-plus-circle'}`} aria-hidden="true"></i>
                          </button>
                        )}
                        <span style={{ whiteSpace: 'pre-wrap', display: 'inline' }}>{isExpanded ? desc : shortDesc}</span>
                      </>
                    );
                  })()}
                </td>
                <td style={{ width: '15%' }}>
                  {(() => {
                    let label =
                      c.tramitacao === 'ENVIADO PARA APROVAÇÃO'
                        ? 'AGUARDANDO APROVAÇÃO'
                        : c.tramitacao;
                    let badgeClass = 'badge rounded-pill px-3';
                    switch (c.tramitacao) {
                      case 'ENVIADO PARA APROVAÇÃO':
                        badgeClass += ' bg-info text-dark';
                        break;
                      case 'APROVADO':
                        badgeClass += ' bg-success';
                        break;
                      case 'REPROVADO':
                        badgeClass += ' bg-danger';
                        break;
                      case 'DEVOLVIDO PARA AJUSTES':
                        badgeClass += ' bg-warning text-dark';
                        break;
                      default:
                        badgeClass += ' bg-secondary';
                    }
                    return <span className={badgeClass}>{label}</span>;
                  })()}
                </td>
                {/* Coluna 'Ações' removida */}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                Nenhum registro encontrado.
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
          <PageFooter>
            <Pagination10 {...setPagination} />
          </PageFooter>
          <DefaultModal {...setDefaultModal} />
          <ConfirmModal {...setConfirmModal} />
          <ReprovaDfdModal
            isOpen={setReprovaDfdModal.isOpen}
            dfd={setReprovaDfdModal.dfd}
            onClose={closeReprovaDfdModal}
            onSuccess={justificativa => {
              setReprovaDfdModal.onSuccess(justificativa);
              closeReprovaDfdModal();
            }}
          />
          <DevolveDfdModal
            isOpen={setDevolveDfdModal.isOpen}
            dfd={setDevolveDfdModal.dfd}
            onClose={closeDevolveDfdModal}
            onSuccess={justificativa => {
              setDevolveDfdModal.onSuccess(justificativa);
              closeDevolveDfdModal();
            }}
          />
          <ReverteDfdModal
            isOpen={setReverteDfdModal.isOpen}
            dfd={setReverteDfdModal.dfd}
            onClose={closeReverteDfdModal}
            onSuccess={justificativa => {
              setReverteDfdModal.onSuccess(justificativa);
              closeReverteDfdModal();
            }}
          />
        </PageContent>
      </ResponsiveShadow>
    </Layout>
  );
}

export default AprovaDfd;
